import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { BaseSessionService } from '../services/base-session.service';

/**
 * Ensures the user has selected a role from the landing page before accessing login.
 * Redirects to landing page if no roleId is found in session storage.
 */
export const roleSelectionGuard: CanActivateFn = () => {
  const session = inject(BaseSessionService);
  const router = inject(Router);

  const roleId = session.getSelectedRoleId();

  if (!roleId) {
    // Pass error message via query params so landing page can show it
    return router.createUrlTree(['/'], {
      queryParams: { error: 'role-required' }
    });
  }

  return true;
};
